/*
  IWA TR teslimat kartı (snippets/iwa-delivery-card.liquid), sepet satırlarının altındaki
  teslim tarihi (snippets/cart-item.liquid; metin ve dil snippets/iwa-delivery-cart-config.liquid)
  ve taksit satırı (snippets/iwa-installment-line.liquid).

  Tahmini teslim (owner, 26 Eki) = kargoya veriliş + 1–2 iş günü kargo. Kargoya veriliş her
  varyant için Liquid'de hesaplanır (snippets/iwa-delivery-dispatch: stokta 1 iş günü, değilse
  IWA US'ten taşınan üretim süresi) ve buraya "mode,min,max" olarak gelir.
  İş günü Pzt–Cum, resmî tatiller hariç; sayım siparişin verildiği günden (İstanbul) başlar,
  saat 04:00'ten önce verilen sipariş bir önceki günün siparişidir (owner, 26 Eki).
  Sepet tek koli gider: en yavaş satır karar verir, her satır aynı tarihi gösterir.
  Taksit satırında varyant değişince aylık tutar (fiyat ÷ taksit sayısı) güncellenir.
  Kart, sepet ve taksit satırı bu dosyayı ayrı ayrı yükleyebilir; ikinci yükleme hiçbir şey yapmaz.
*/
(function () {
  'use strict';
  if (window.IWADeliveryTR) return;

  var TRANSIT = [1, 2];
  var DAY_STARTS = 4; // saat 04:00'ten önceki sipariş bir önceki günün
  // TR resmî tatilleri: IWA US iwa.delivery_config holidays.TR (calib-2026-10-25). 2027 sonuna kadar; sonrası eklenmeli.
  var HOLIDAYS = ['2026-10-29', '2027-01-01', '2027-03-09', '2027-03-10', '2027-03-11', '2027-04-23', '2027-05-01',
    '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19', '2027-07-15', '2027-08-30', '2027-10-29'];

  // ---------------------------------------------------------------- takvim
  // Tarihler 'YYYY-MM-DD' metni (İstanbul takvimi).
  function addDays(iso, n) {
    return new Date(Date.parse(iso + 'T00:00:00Z') + n * 864e5).toISOString().slice(0, 10);
  }
  function isWork(iso) {
    var d = new Date(iso + 'T00:00:00Z').getUTCDay();
    return d >= 1 && d <= 5 && HOLIDAYS.indexOf(iso) === -1;
  }
  function addWork(iso, n) {
    for (; n > 0; n--) {
      do { iso = addDays(iso, 1); } while (!isWork(iso));
    }
    return iso;
  }
  function orderDay(now) {
    var p = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date()).forEach(function (x) { p[x.type] = x.value; });
    var iso = p.year + '-' + p.month + '-' + p.day;
    return Number(p.hour) < DAY_STARTS ? addDays(iso, -1) : iso;
  }

  // ranges: her kargolanan satırın kargoya veriliş aralığı [min, max] (iş günü) → { from, to } ya da null
  function promise(ranges, now) {
    if (!ranges.length) return null;
    var min = 0;
    var max = 0;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (!r || isNaN(r[0]) || isNaN(r[1])) return null;
      min = Math.max(min, r[0]);
      max = Math.max(max, r[1]);
    }
    var d0 = orderDay(now);
    return { from: addWork(d0, min + TRANSIT[0]), to: addWork(d0, max + TRANSIT[1]) };
  }

  // "28 Eki Çar"; ar Latin rakamlarla.
  function fmt(iso, locale) {
    var l = locale === 'ar' ? 'ar-u-nu-latn' : (locale === 'en' ? 'en-GB' : (locale || 'tr'));
    return new Intl.DateTimeFormat(l, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })
      .format(new Date(iso + 'T12:00:00Z'));
  }
  function rangeText(template, p, locale) {
    return template.replace('__FROM__', fmt(p.from, locale)).replace('__TO__', fmt(p.to, locale));
  }
  // "stock,1,1" → { mode, range }
  function parseDispatch(s) {
    var a = String(s || '').split(',');
    return { mode: a[0], range: [Number(a[1]), Number(a[2])] };
  }

  // ---------------------------------------------------------------- kart
  function modes(card) {
    if (!card._iwaModes) {
      try {
        card._iwaModes = JSON.parse(card.querySelector('[data-iwa-delivery-modes]').textContent);
      } catch (e) {
        card._iwaModes = {};
      }
    }
    return card._iwaModes;
  }

  function updateCard(card, variantId) {
    var d = modes(card)[String(variantId)];
    if (!d) return;
    var mode = d[0];
    var range = [d[1], d[2]];
    card.hidden = false;
    var line = card.querySelector('[data-iwa-dispatch]');
    var template = line && line.getAttribute('data-' + mode);
    if (template) line.textContent = template.replace('__DAYS__', range[0] === range[1] ? range[0] : range[0] + '–' + range[1]);
    var arrives = card.querySelector('[data-iwa-delivery-arrives]');
    if (arrives) {
      var p = promise([range]);
      arrives.textContent = p ? rangeText(arrives.getAttribute('data-template'), p, card.dataset.locale) : '';
      arrives.hidden = !p;
      arrives.classList.remove('is-pending');
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && (e.detail.variant || e.detail);

    document.querySelectorAll('[data-iwa-delivery]').forEach(function (card) {
      if (!variant || !variant.id) {
        card.hidden = true;
        return;
      }
      updateCard(card, variant.id);
    });

    document.querySelectorAll('[data-iwa-installment]').forEach(function (el) {
      var amount = el.querySelector('[data-iwa-installment-amount]');
      var n = Number(el.getAttribute('data-count')) || 0;
      if (!variant || !variant.id || !amount || n < 2) return;
      amount.textContent = amount.getAttribute('data-template').replace('__AMOUNT__', formatMoney(Math.round(variant.price / n)));
    });
  });

  // ---------------------------------------------------------------- sepet satırları
  // Çekmece ve sepet sayfası aynı sepetin iki listesi ([data-products]); her biri ayrı hesaplanır.
  var CART_LISTS = '#CartDrawerForm [data-products], #CartPageForm [data-products]';
  var cartTimer = null;
  function fillCart() {
    var conf;
    try {
      conf = JSON.parse(document.querySelector('[data-iwa-delivery-cart-config]').textContent);
    } catch (e) {
      return;
    }
    document.querySelectorAll(CART_LISTS).forEach(function (list) {
      var hooks = list.querySelectorAll('[data-iwa-cart-arrives]');
      if (!hooks.length) return;
      var p = promise(Array.prototype.map.call(hooks, function (h) { return parseDispatch(h.getAttribute('data-dispatch')).range; }));
      var text = p ? rangeText(conf.arrives, p, conf.locale) : '';
      hooks.forEach(function (h) {
        var t = h.querySelector('[data-iwa-cart-arrives-text]');
        if (t && t.textContent !== text) t.textContent = text;
        h.hidden = !text;
      });
    });
  }
  function scheduleCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(fillCart, 0);
  }
  // Çekmece ve sepet sayfası her değişiklikte satırları ([data-products] altındakiler) yeniden
  // kurar; yalnızca o seviye izlenir, metni doldurmak gözlemciyi yeniden tetiklemez.
  function watchCart() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(scheduleCart);
    document.querySelectorAll(CART_LISTS).forEach(function (list) {
      mo.observe(list, { childList: true });
    });
  }
  document.addEventListener('ajaxProduct:added', scheduleCart);
  document.addEventListener('cart:updated', scheduleCart);

  window.IWADeliveryTR = { promise: promise, fillCart: fillCart, _fmt: fmt };

  function start() {
    document.querySelectorAll('[data-iwa-delivery]').forEach(function (card) {
      if (card.dataset.variantId) updateCard(card, card.dataset.variantId);
    });
    fillCart();
    watchCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
